import React from 'react';
import '../components/PrivacyPolicy.css'; // Optional, for simple custom styles

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy for Oopss</h1>
      <p><strong>Effective Date:</strong> 13-10-2025</p>

      <p>
        <strong>Oopss</strong> is a mobile application operated by <strong>Shree Enterprises</strong> for the purpose of selling stationery items in Goa.
        This app is developed by <strong>Sujal Dave</strong>.
      </p>

      <p>We respect your privacy and are committed to protecting the personal information you provide while using our app.</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Personal Information:</strong> Name, phone number, email address, and delivery address.</li>
        <li><strong>Usage Data:</strong> App usage, pages visited, and interactions.</li>
        <li><strong>Device Information:</strong> Device model, operating system, and IP address.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Process orders and deliver stationery items.</li>
        <li>Communicate with you regarding your orders or updates.</li>
        <li>Improve our services and user experience.</li>
        <li>Ensure app security and prevent misuse.</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>We do <strong>not</strong> sell or rent your personal information. We may share your data with:</p>
      <ul>
        <li>Delivery partners, to fulfill your orders.</li>
        <li>Service providers who help operate the app (e.g., payment gateways).</li>
        <li>Authorities, if required by law.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>We take reasonable steps to protect your data from unauthorized access or disclosure. However, no method of online transmission is 100% secure.</p>

      <h2>5. Your Rights</h2>
      <ul>
        <li>Request access to the data we hold about you.</li>
        <li>Ask us to correct or delete your data.</li>
        <li>Withdraw consent at any time (this may affect your ability to use the app).</li>
      </ul>

      <h2>6. Children's Privacy</h2>
      <p>The app is not intended for children under the age of 13. We do not knowingly collect data from children.</p>

      <h2>7. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Changes will be posted within the app.</p>

      <h2>8. Contact Us</h2>
      <p>
        <strong>Shree Enterprises – Goa</strong><br />
        Email: [Insert Email Address]<br />
        Phone: [Insert Phone Number]
      </p>

      <p><em>App Developed by Sujal Dave</em></p>
    </div>
  );
};

export default PrivacyPolicy;
